/** A Vietnamese tax code: 10 digits, or 10 digits-NNN for a branch. */
export const TAX_CODE_PATTERN = /^\d{10}(-\d{3})?$/;

export type CompanyInfo = { company: string; address: string };

type EscodataResponse = {
  error: number;
  error_text?: string;
  // Head offices come back as { ten, dc }, branches as { name, address }.
  data?: { ten?: string; dc?: string; name?: string; address?: string } | [];
};

/**
 * Looks up a company by tax code through the public escodata.net API
 * (https://escodata.net/api-lay-thong-tin-doanh-nghiep-tu-ma-so-thue-bv4.htm).
 * Resolves to null when the tax code is unknown.
 */
export async function lookupCompanyByTaxCode(taxCode: string, signal?: AbortSignal): Promise<CompanyInfo | null> {
  const response = await fetch(`https://escodata.net/api-mst/${encodeURIComponent(taxCode)}.htm`, { signal });
  if (!response.ok) throw new Error(`Tax code lookup failed (${response.status})`);
  const body = (await response.json()) as EscodataResponse;
  if (body.error !== 0 || !body.data || Array.isArray(body.data)) return null;
  const company = (body.data.ten ?? body.data.name ?? '').trim();
  const address = (body.data.dc ?? body.data.address ?? '').trim();
  return company ? { company, address } : null;
}
